export enum ActivityStatusEnum {
  ACTIVE = 1,
  INACTIVE = 2,
  DONE = 3,
  PLANNED = 4
}
